import React from 'react';

const CurrentIcon = () => {
  return (
    <svg
      width='45'
      height='45'
      viewBox='0 0 45 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='45' height='45' rx='4' fill='#5B91F5' fillOpacity='0.1' />
      <path
        d='M18.368 29V24.482H17.18V23.222H18.368V21.854H17.18V20.594H18.368V16.148H20.834L22.346 20.594H24.164V16.148H25.946V20.594H27.116V21.854H25.946V23.222H27.116V24.482H25.946V29H23.462L21.914 24.482H20.132V29H18.368ZM20.132 23.222H21.518L21.068 21.854H20.096L20.132 23.222ZM24.2 26.3H24.29L24.218 24.482H23.624L24.2 26.3ZM20.078 20.594H20.672L20.06 18.668H19.988L20.078 20.594ZM23.228 23.222H24.2L24.164 21.854H22.778L23.228 23.222Z'
        fill='#5B91F5'
      />
    </svg>
  );
};

export default CurrentIcon;
